import React, { useEffect, useRef } from 'react';
import './Sigiriya.css';
import ella1 from '../../img/webp/ella1.webp';
import ella2 from '../../img/webp/ella2.webp';
import ella3 from '../../img/webp/ella3.webp';
import ella4 from '../../img/webp/ella4.webp';
import DestinationSuggestions from '../../components/DestinationSuggestions';
import { getRandomSuggestions } from '../../data/destinationsData';
import SearchBar from '../../components/SearchBar';

const Ella = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="destination-page">
      <SearchBar contentRef={contentRef} placeholder="Search Ella information..." />
      
      <div ref={contentRef}>
      {/* Hero Section */}
      <section className="dest-hero">
        <img src={ella1} alt="Ella" />
        <div className="dest-badge">Ella</div>
      </section>

      {/* Main Content Section */}
      <section className="dest-content">
        <div className="dest-container">
          <div className="dest-main-section">
            <div className="dest-left">
              <img src={ella2} alt="Ella mountains" />
            </div>
            <div className="dest-right">
              <h1 className="dest-title">Discover Ella</h1>
              <p className="dest-description">
                A scenic hill-country town surrounded by misty mountains, waterfalls, and lush greenery.
              </p>
              
              <ul className="dest-features">
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Comfortable hill-country travel
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Flexible hiking schedules
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Calm and refreshing atmosphere
                </li>
              </ul>

              <div className="dest-meta">
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>Land Trip</span>
                </div>
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>2 Days</span>
                </div>
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="9 22 9 12 15 12 15 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Sightseeing</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="dest-bottom-section">
            <div className="dest-bottom-left">
              <p className="dest-bottom-text">
                Ella is a peaceful town located in Sri Lanka's central highlands, known for its cool climate and stunning landscapes. It is surrounded by tea plantations, rolling hills, and dramatic rock formations, making it ideal for nature lovers.
              </p>
              <p className="dest-bottom-text">
                Popular attractions include Ella Rock, Little Adam's Peak, and the Nine Arches Bridge. The relaxed vibe, fresh air, and scenic beauty make Ella a favorite destination for both local and international travelers.
              </p>
            </div>
            <div className="dest-bottom-right">
              <img src={ella3} alt="Ella landscape" />
            </div>
          </div>

          {/* Ceylon D Tour Section */}
          <div className="dest-main-section" style={{ marginTop: '4rem' }}>
            <div className="dest-left">
              <img src={ella4} alt="Ceylon D Tour Ella experience" />
            </div>
            <div className="dest-right">
              <p className="dest-description">
                Ceylon D Tour offers personalized Ella travel experiences with comfortable transportation, flexible schedules, and expert local guidance. Our tour packages include visits to scenic viewpoints, hiking trails, tea estates, and waterfall excursions around Ella. We also arrange accommodation assistance and combined tours to nearby attractions such as the Nine Arch Bridge and Ravana Falls. With Ceylon D Tour, you can explore Ella's natural beauty at your own pace while enjoying seamless travel arrangements and unforgettable hill-country adventures.
              </p>
            </div>
          </div>
      {/* Destination Suggestions */}
      <DestinationSuggestions 
        currentDestination="Ella"
        suggestions={getRandomSuggestions('/places/ella', 4)}
      />

        </div>
      </section>

      </div> {/* End of contentRef */}
    </div>
  );
};

export default Ella;

